import { render } from "./Carousel.vue?vue&type=template&id=6ff16fbc&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=6ff16fbc&lang=scss"
import "./Carousel.vue?vue&type=style&index=1&id=6ff16fbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff16fbc"]])

export default __exports__